/**
 * Created by Administrador on 23/08/2019.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('reprintService',reprintService);

    reprintService.$inject = ['$http', 'CONFIG','messageService'];

    function reprintService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FINANCE + '/' + CONFIG.API + '/eTickets';

        var service = {
            getETicketById: getETicketById,
            getSearchByPnr: getSearchByPnr,
            getSearchWithoutTicketByPnr: getSearchWithoutTicketByPnr,
            getGeneralReportByFlightPdf: getGeneralReportByFlightPdf,
            getGeneralReportByDeparture: getGeneralReportByDeparture,
            getByInvoiceNumberAndNitClient: getByInvoiceNumberAndNitClient
        };

        return service;

        function getETicketById(id){
            return $http.get(urlBase + '/' + id)
                .then(function(response){
                    return (response.data) ? response.data : [];
                }, function(){
                    messageService.findError('');
                });
        }

        function getSearchByPnr(code,page, size){
            return $http.get(urlBase + '/search-by-pnr?pnr=' + code +'&page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getSearchWithoutTicketByPnr(code,page, size){
            return $http.get(urlBase + '/search-by-pnr/without-ticket?pnr=' + code +'&page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getGeneralReportByFlightPdf(status, flightId, detail){
            return $http.get(urlBase + '/flight/pdf?' + status + 'flightId=' + flightId+'&detail='+detail )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getGeneralReportByDeparture(status, departureFlightId, detail){
            return $http.get(urlBase + '/departure?' + status + 'departureFlightId=' + departureFlightId+'&detail='+detail )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getByInvoiceNumberAndNitClient(invoiceNumber, nitClient){
            return $http.get(urlBase + '/byInvoiceNumberAndNitClient/' + invoiceNumber + '/' +nitClient )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }
    }
})();
